export const timePickerDayPeriodButtonTestId = 'timePickerDayPeriodButtonTestId';
